/* V74: make the shared native <details> navigation dismissible site-wide. */
(() => {
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.os74-shop-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    document.querySelectorAll('.os74-shop-menu[open]').forEach(menu => {
      menu.open = false;
      if (menu.contains(active)) menu.querySelector(':scope > summary')?.focus();
    });
  });
})();
